import type { AttachmentUploads } from "./attachment-uploads.svelte.js";

// This registry must not import the upload transport or application state:
// drafts uses it during account cleanup, before that graph is initialized.
const conversationUploads = new Map<string, AttachmentUploads>();

export function retainConversationUploads(
  key: string,
  create: () => AttachmentUploads,
): AttachmentUploads {
  const existing = conversationUploads.get(key);
  if (existing) return existing;
  // An empty manager can still belong to a mounted composer.
  const uploads = create();
  conversationUploads.set(key, uploads);
  return uploads;
}

/**
 * Drop a conversation's manager once it holds nothing. A manager with staged files
 * stays — surviving a remount is the whole point of this registry — but an EMPTY one
 * for a conversation the user merely looked at has nothing to survive, and one
 * accumulated per stop as they walked the sidebar.
 */
export function releaseConversationUploads(key: string): void {
  const uploads = conversationUploads.get(key);
  if (uploads && !uploads.hasAny) conversationUploads.delete(key);
}

export function clearConversationUploads(): void {
  for (const uploads of conversationUploads.values()) uploads.clear();
  conversationUploads.clear();
}
